/* Library */
import React, { Component } from "react";
import { connect } from "react-redux";
import { browserHistory } from "react-router";
import { bindActionCreators } from "redux";
import commonUtil from "../../../../../utils/commonUtil";
import serverClientUtil from "../../../../../utils/serverClientUtil";
import ApplyCSS from "../../../../../components/ApplyCSS";
import Tagging from "../../../../../components/Tagging";
import {
  handleUserLogout,
  _handleUserLogin,
} from "../../../../../pages/Accounts/createAccount/actions";
import * as BrowseAndNevigateSearchAction from "../../../../../pages/BrowseAndNavigate/BrowseAndNevigateSearch/actions";
import LoginModal from "../../../../../pages/Accounts/createAccount/components/loginModal";
import TypeHeadLeft from "../../../../../components/GREcomHeader/headers/CommonTypeHeadLeft/index";
import NewTypeHeadLeft from "../../../../../components/GREcomHeader/headers/NewCommonTypeHeadLeft/index";
import HeaderTopContainer from "../../NewHeaderGAP/components/HeaderTopContainer";
import { menusHeader } from "../../../../NewHeader/mocks/headerContent";
import * as NewBrowseAndNevigateSearchAction from "../../../../../pages/BrowseAndNavigate/NewBrowseAndNevigateSearch/actions";
import MegaMenu from "../components/MegaMenu";
const textNodeServices = "servicios";
const textNodeOtherSites = "otros sitios";

const headerData = "";
const applicationRoutes = commonUtil.getApplicationRoutes();
//const { IS_MISCOMPRAS } = process.env;

class NewHeaderPB extends Component {
  constructor(props) {
    super(props);
    const { linksMenuData, newLinksMenuData } = props;
    const {
      menuWapPathsConfigLogged,
    } = linksMenuData || {};
    const { topRightLinks, userDataDropdownGuest, userDataDropdownLogged } = newLinksMenuData || {};

    const dropdownGuess = menusHeader.userDataDropdownGuest.links;
    const dropdownLogged = menusHeader.userDataDropdownLogged.links;
    const pathWapLogged = menusHeader.menuWapPathsConfigLogged.links;
    const headerTopRightLinks = menusHeader.topRightLinks;
    const menuCategories = menusHeader.megaMenu[0];
    const categoriesResponse = props.newMegaMenuData.l1Categories
      ? props.newMegaMenuData
      : null;

    this.megaMenuData = categoriesResponse || menuCategories;
    this.topRightLinks =
      topRightLinks && topRightLinks.links
        ? topRightLinks
        : headerTopRightLinks;
    this.userDataDropdownGuest =
      (userDataDropdownGuest && userDataDropdownGuest.links) || dropdownGuess;
    this.userDataDropdownLogged =
      (userDataDropdownLogged && userDataDropdownLogged.links) ||
      dropdownLogged;
    this.menuWapPathsConfigLogged =
      (menuWapPathsConfigLogged && menuWapPathsConfigLogged.links) ||
      pathWapLogged;

    this.state = {
      headerContent: headerData,
      onHoverClass: "no-hover",
      inputSearch: "",
      otherSites: [],
      servicesData: [],
      services: [],
    };

    this.handleMouseLeave = this.handleMouseLeave.bind(this);
    this.handleMouseEnter = this.handleMouseEnter.bind(this);
    this.generateSubChildCategories =
      this.generateSubChildCategories.bind(this);
    this.generateChildCategories = this.generateChildCategories.bind(this);
    this.generateSubCategories = this.generateSubCategories.bind(this);
    this.checkSession = this.checkSession.bind(this);
    this.searchProduct = this.searchProduct.bind(this);
    this.cartCount = 0;
    this.clickHandlerLogo = this.clickHandlerLogo.bind(this);
  }
  clickHandlerLogo() {
    // eslint-disable-line class-methods-use-this
    const _url = serverClientUtil.getLPFullURL();
    window.location = _url;
  }
  handleMouseEnter() {
    this.setState({ onHoverClass: "hover-ready" });
  }
  handleMouseLeave() {
    this.setState({ onHoverClass: "no-hover" });
  }
  cartOpenClose = () => {
    document
      .querySelector(".dropdown-menu.bag_01")
      .classList.toggle("cartopen");
  };

  getData() {
    console.log("New header component calling?...");
    const topRightLinks =
      (this.props.newLinksMenuData &&
        this.props.newLinksMenuData.topRightLinks &&
        this.props.newLinksMenuData.topRightLinks.links) ||
      [];
    const { userDataDropdownGuest, userDataDropdownLogged } =
      (this.props.newLinksMenuData &&
        this.props.newLinksMenuData) ||
      {};
    const userDataDropdownGuestData =
      (userDataDropdownGuest && userDataDropdownGuest.links) ||
      this.userDataDropdownGuest;
    const userDataDropdownLoggedData =
      (userDataDropdownLogged && userDataDropdownLogged.links) ||
      this.userDataDropdownLogged;
    const { links } = this.topRightLinks;
    const findNodeExtraData = (textNode) =>
      links.find((itemData) => itemData.text?.toLowerCase() === textNode);
    const findNewNodeExtraData = (textNode) =>
      links.find((itemData) => itemData.label?.toLowerCase() === textNode);
    const servicesData = findNewNodeExtraData(textNodeServices)?.items;
    const otherSitesData = findNewNodeExtraData(textNodeOtherSites)?.items;
    const categoriesResponse = this.props.newMegaMenuData.l1Categories
      ? this.props.newMegaMenuData
      : null;
    const headerTopRightLinks = menusHeader.topRightLinks;
    this.setState({
      ...this.state,
      servicesData,
      otherSites: otherSitesData,
      categories: categoriesResponse || this.megaMenuData,
      topRightLinks:
        topRightLinks.length > 0 ? topRightLinks : headerTopRightLinks,
      userDataDropdownGuest: userDataDropdownGuestData,
      userDataDropdownLogged: userDataDropdownLoggedData,
    });
  }

  // TODO: this all next 4 functuons are used to show megamenu and integrated with actual service but still need to fix some work.
  generateSubChildCategories = (childCategory, subCategory) => (
    <ul>
      {childCategory
        ? this.generateRootCategories(childCategory.l3subcategories)
        : null}
      {childCategory.l3subcategories.length > 8 ? (
        <li>
          <a href={serverClientUtil.getLPURL() + childCategory.url}>
            {" "}
            Ver Mas+
          </a>
        </li>
      ) : null}
    </ul>
  );

  generateChildCategories = (subCategory, categoryName) => {
    if (subCategory) {
      return (
        <div className="m-body_department">
          <a href="" className="a-department_title">
            {categoryName}
          </a>
          <div className="m-deparments_content-categorys flx">
            <div className="m-nav_content-category">
              {subCategory &&
              subCategory.l2subcategories &&
              subCategory.l2subcategories.length > 0
                ? subCategory.l2subcategories.map((childCategory, index) => {
                    if (index < 3) {
                      return (
                        <div className="m-nav-categorys" key={index}>
                          <h3
                            className="a-category_title"
                            id={childCategory.id}
                          >
                            {childCategory.name}
                          </h3>
                          {this.generateSubChildCategories(
                            childCategory,
                            subCategory
                          )}
                        </div>
                      );
                    }
                    return null;
                  })
                : null}
            </div>
            <div className="m-nav_content-banner">
              <div>
                <a
                  className="a-desktop__subcategoryImg"
                  href={serverClientUtil.getLPURL() + subCategory.url}
                >
                  <figure>
                    <img
                      className="a-desktop__subcategoryImg"
                      src={subCategory.imageUrl}
                    />
                  </figure>
                </a>
              </div>
            </div>
            <a
              href={serverClientUtil.getLPURL() + subCategory.url}
              className="allSections"
            >
              Ver todas las secciones
            </a>
          </div>
        </div>
      );
    }
    return null;
  };

  generateSubCategories = (L1subcategories) => (
    <div className="m-popover">
      {L1subcategories && L1subcategories.length > 0
        ? L1subcategories.map((subCategory, index) => (
            <div
              className="m-nav-department"
              onClick={this.handleMouseLeave}
              key={index}
            >
              <a
                href={serverClientUtil.getLPURL() + subCategory.url}
                className="a-nav-department"
              >
                {subCategory.name}
                <span className="icon-flecha_lightsvg_derecha" />
              </a>
              {this.generateChildCategories(subCategory, subCategory.name)}
            </div>
          ))
        : null}
    </div>
  );
  generateRootCategories = (rootCategories) =>
    rootCategories && rootCategories.length > 0
      ? rootCategories.map((rootCategory, index) => {
          if (index < 8) {
            return (
              <li>
                <a
                  className="a-nav-catLink"
                  id={rootCategory.id}
                  href={serverClientUtil.getLPURL() + rootCategory.url}
                >
                  {rootCategory.name}
                </a>
              </li>
            );
          }
          return null;
        })
      : null;
  handleUserLogout(email) {
    const url = serverClientUtil.getLPFullURL();
    this.props.handleLogoutWithAuth0(email, this.props.handleUserLogout, url);
  }
  componentDidMount() {
    this.checkSession();
    this.getData();
    document.addEventListener("click", (e) => {
      this.closeSearchTab(e);
    });
  }
  closeSearchTab = (e) => {
    if (
      e.target &&
      document.querySelector("#typeahead") &&
      !document.querySelector("#typeahead").contains(e.target) &&
      document.querySelector("#typeahead").style.display === "block"
    ) {
      document.querySelector("#typeahead").style.display = "none";
    }
  };
  handOnKeyUp = (e) => {
    e.preventDefault();
    if (e.keyCode === 13) {
      window.open(
        serverClientUtil.getLPFullURL() + "?s=" + e.target.value,
        "_self"
      );
    }
  };
  getTaggingData = (data) => {
    const _dataLayer = {};
    _dataLayer.event = "TSearch";
    _dataLayer.Section = data;
    return _dataLayer;
  };
  getTaggingDataFailure = (data) => {
    const _dataLayer = {};
    _dataLayer.event = "ESearch";
    _dataLayer.STerm = data;
    return _dataLayer;
  };
  checkSession = () => {
    if (this.props.user.loaded) {
      this._ajaxLoad.style.display = "none";
      if (
        this._loginLi &&
        this.props.user &&
        this.props.user.data &&
        this.props.user.data.result &&
        this.props.user.data.result.firstName
      ) {
        this._loginLi.style.display = "inline-block";
        this._logoutLi.style.display = "none";
      } else if (
        this._loginLi &&
        this.props.user.data.actionType === "logout" &&
        this.props.user.data.result.status.status === "success" &&
        document !== undefined
      ) {
        this._loginLi.style.display = "none";
        this._logoutLi.style.display = "inline-block";
        if (window) {
          window.location.href = "/";
        }
      } else if (
        this._loginLi &&
        this.props.user.data.actionType === "activeSession"
      ) {
        this._loginLi.style.display = "none";
        this._logoutLi.style.display = "inline-block";
      } else if (
        this._loginLi &&
        this.props.user.data.actionType === "login" &&
        this.props.user.data.result.status.status === "failure"
      ) {
        this._loginLi.style.display = "none";
        this._logoutLi.style.display = "inline-block";
      } else {
        this._logoutLi.style.display = "none";
        this._loginLi.style.display = "none";
        this._ajaxLoad.style.display = "inline-block";
      }
    }
  };
  searchProduct = () => {
    const enteredData = document.querySelector("#search").value;
    let { SearchedDetailOfPoduct, BFFSearchedDetailOfPoduct } = this.props;
    SearchedDetailOfPoduct = BFFSearchedDetailOfPoduct;
    this.setState({ inputSearch: enteredData });
    SearchedDetailOfPoduct(enteredData, {}).then((res) => {
      if (res.status.status === "success") {
        const _dataLayer = this.getTaggingData(enteredData);
        this.tagging.applyGTM("SearchProduct", _dataLayer);
      } else {
        const _dataLayer = this.getTaggingDataFailure(enteredData);
        this.tagging.applyGTM("SearchProduct", _dataLayer);
      }
    });
  };
  render() {
    const { servicesData, otherSites: otherSitesData, categories } = this.state;
    const {
      home,
      handleLoginWithAuth0,
      handleLogoutWithAuth0,
      routerPaths,
      returnClickHandler,
      user = {},
    } = this.props;
    const { SearchedPoductData } = this.props;
    const email =
      this.props.user && this.props.user.data && this.props.user.data.result
        ? this.props.user.data.result.emailId
        : "";
    if (this._loginLi) {
      this.checkSession();
    }
    if (SearchedPoductData && SearchedPoductData.suggestion) {
      document.querySelector("#typeahead").style.display = "block";
      document.querySelector("#typeahead").style.background = "#fff"; // TOD: Temp css applied. will emove it later.
      document.querySelector("#typeahead").style.zIndex = 999;
    }
    this.cartCount = 0;
    if (
      this.props.cartCountData &&
      this.props.cartCountData.cartDetails &&
      this.props.cartCountData.cartDetails.length > 0
    ) {
      this.props.cartCountData.cartDetails.map(
        (data) => (this.cartCount += parseInt(data.quantity, 10))
      );
    }
    return (
      <header className="nav-bar">
        <ApplyCSS pageName="headerPB" />
        <Tagging ref={(tagging) => (this.tagging = tagging)} />
        <HeaderTopContainer
          services={servicesData}
          otherSites={otherSitesData}
          linksHeaderTop={this.topRightLinks}
          home={home}
        />
        <div className="nav-search_bar flx">
          <div className="o-container">
            <figure className="m-nav-search_logo p-x1">
              <a href={serverClientUtil.getLPFullURL() + "/home"}>
                <img
                  className="a-nav-search_logo"
                  src={commonUtil.getAssetURL() + "/images/logo-pb.png"}
                  alt="Liverpool - Es parte de mi vida"
                  title="Liverpool - es parte de mi vida"
                />
              </a>
            </figure>
            <div className="m-nav-search_input p-x1">
              <form className="nav-form">
                <div className="nav-form_control">
                  <input
                    id="search"
                    autoComplete="off"
                    type="text"
                    placeholder="Buscar..."
                    onChange={this.searchProduct}
                    onKeyUp={(e) => {
                      this.handOnKeyUp(e);
                    }}
                  />
                  <span className="icon-zoom" />
                </div>
                <div id="typeahead" style={{ display: "none" }}>
                  {SearchedPoductData && SearchedPoductData.suggestion ? (
                    <div className="m-typeAhead">
                      <NewTypeHeadLeft
                        {...this.props}
                        inputSearch={this.state.inputSearch}
                        color={"#990000"}
                      />
                      <div className="m-typeAhead__right">
                        <p className="a-typeAhead__title">Lo más buscado</p>
                        <div className="m-typeAhead__results">
                          <React.Fragment>
                            {SearchedPoductData &&
                            SearchedPoductData.suggestion &&
                            SearchedPoductData.suggestion.products
                              ? SearchedPoductData.suggestion.products.map(
                                  (data) => (
                                    <div className="m-typeAhead__resultCard">
                                      <a
                                        href={
                                          serverClientUtil.getLPURL() + data.url
                                        }
                                      >
                                        <figure className="m-resultCard__figure">
                                          {data &&
                                          data.imgUrl &&
                                          data.imgUrl !== null &&
                                          data.imgUrl !== "null" &&
                                          data.imgUrl !== undefined &&
                                          data.imgUrl !== "undefined" ? (
                                            <img
                                              id={"ahead_" + data.productId}
                                              alt={data.productName}
                                              src={data.imgUrl}
                                            />
                                          ) : (
                                            <img
                                              id={"ahead_defaultImage"}
                                              alt={"ahead_defaultImage"}
                                              src={
                                                commonUtil.getAssetURL() +
                                                "/images/filler_REC.gif"
                                              }
                                            />
                                          )}
                                          <figcaption className="a-resultCard__title">
                                            <p className="a-resultCard__title">
                                              {data.productName}
                                            </p>
                                          </figcaption>
                                        </figure>
                                      </a>
                                    </div>
                                  )
                                )
                              : null}
                          </React.Fragment>
                        </div>
                      </div>
                    </div>
                  ) : null}
                </div>
              </form>
            </div>
            <LoginModal
              ref={(login) => (this.loginModal = login)}
              _handleUserLogin={this.props._handleUserLogin}
              myProps={this.props}
              label={this.props.label}
            />
            <div className="m-nav-search_myorders p-x1">
              <a
                href={
                  serverClientUtil.getLPFullURL() +
                  serverClientUtil.getMisComprasURL()
                }
                className="a-nav-a"
              >
                {serverClientUtil.getMisComprasText()}
              </a>
            </div>
            <div className="m-nav-search_session p-x1">
              <button
                className="a-nav-a a-btn_empty"
                style={{ display: "none" }}
                onClick={this.props.handleLoginWithAuth0}
                ref={(_logoutLi) => (this._logoutLi = _logoutLi)}
              >
                <a>Iniciar sesión </a>
              </button>
              <div
                className="m-session_user"
                style={{ display: "none" }}
                ref={(_loginLi) => (this._loginLi = _loginLi)}
              >
                <div className="a-nav-a a-session_user">
                  Hola{" "}
                  {this.props.user.loaded &&
                  this.props.user.data &&
                  this.props.user.data.result
                    ? this.props.user.data.result.firstName
                    : null}
                  <span className="icon-flecha_gruesa_abajo" />
                </div>
                <div className="m-session_menu m-popover">
                  <ul>
                    <li>
                      <a
                        href={
                          serverClientUtil.getLPFullURL() + "/users/myAccount"
                        }
                        className="a-nav-link"
                      >
                        <span>Mi cuenta</span>
                      </a>
                    </li>
                    <li>
                      <a
                        href={
                          serverClientUtil.getLPFullURL() +
                          serverClientUtil.getMisComprasURL()
                        }
                        className="a-nav-link"
                      >
                        <span>{serverClientUtil.getMisComprasText()}</span>
                      </a>
                    </li>
                    <li>
                      <a
                        href={
                          serverClientUtil.getLPFullURL() +
                          "/checkout/airtimeTicket"
                        }
                        className="a-nav-link"
                      >
                        <span>Mi Tiempo Aire</span>
                      </a>
                    </li>
                    <li>
                      <a
                        href={
                          serverClientUtil.getLPFullURL() + "/users/creditCards"
                        }
                        className="a-nav-link"
                      >
                        <span>Mis Tarjetas</span>
                      </a>
                    </li>
                    <li>
                      <button
                        className="a-nav-link a-btn_empty"
                        onClick={() => {
                          this.handleUserLogout(email);
                        }}
                      >
                        Cerrar Sesión
                      </button>
                    </li>
                  </ul>
                </div>
                <div
                  className="sessionMenu dropdown login"
                  ref={(_ajaxLoad) => (this._ajaxLoad = _ajaxLoad)}
                >
                  <a>
                    <img
                      src={commonUtil.getAssetURL() + "/images/ajax-loader.gif"}
                      style={{ verticalAlign: "middle", maxHeight: "20" }}
                      width="80"
                      height="80"
                      alt="shop"
                    />
                  </a>
                </div>
              </div>
            </div>
            <div className="m-nav-search_mycart p-x1">
              <a href={serverClientUtil.getLPFullURL() + "/cart"}>
                {this.cartCount >= 0 ? (
                  <React.Fragment>
                    <figure>
                      <img
                        src={commonUtil.getAssetURL() + "/images/bolsita.png"}
                        className="a-mycart_img"
                      />
                      <span className="a-articles">{this.cartCount}</span>
                    </figure>{" "}
                  </React.Fragment>
                ) : null}
              </a>
            </div>
          </div>
        </div>
        <MegaMenu categories={categories} />
      </header>
    );
  }
}
const mapStateToProps = (state) => ({
  label: state.labels.data,
  user: state.user,
  eventDetails: state.eventDetail,
  megaMenuData: state.megaMenuData.data,
  cartCountData: state.cartCountData.data,
  SearchedPoductData: state.NewSearchedPoductData.data,
  globalObject: state.globleObject,
  linksMenuData: state.linksMenuData.data ? state.linksMenuData.data : {},
  home: state.labels.data.home,  newLinksMenuData: state.globalData.data || {},
  newMegaMenuData: state.newMegaMenuData.data,
});
const matchDispatchToProps = (dispatch) =>
  bindActionCreators({ handleUserLogout, _handleUserLogin, ...BrowseAndNevigateSearchAction, ...NewBrowseAndNevigateSearchAction }, dispatch);
export default connect(mapStateToProps, matchDispatchToProps)(NewHeaderPB);
